import type { AlertsWidgetActions } from 'src/store/actions/widgets/alerts';
import type { AlertsWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const alertsReducer = (
    state: WidgetTabViewModel<AlertsWidgetViewModel>,
    action: AlertsWidgetActions,
): WidgetTabViewModel<AlertsWidgetViewModel> => {
    switch (action.type) {
        case 'updateAlertsSymbol': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    linkedSymbol: action.symbol,
                },
            };
        }

        case 'updateActiveAlertsTab': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    activeAlertsTab: action.activeAlertsTab,
                },
            };
        }

        default:
            return state;
    }
};
